import { render, staticRenderFns } from "./depot-select.vue?vue&type=template&id=1ac0955a&"
import script from "./depot-select.vue?vue&type=script&lang=js&"
export * from "./depot-select.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports